<template>
  <div class="p-4" :class="{ 'bg-neutral-lightest': markBgColor }">
    <!-- @TODO remove this ant-form direct dependency make a component to render form item name and value -->
    <MRow>
      <MCol :size="12" class="mb-2 flex flex-1 ml-auto">
        <a
          v-if="allowEdit && !disabled"
          class="text-neutral mr-2"
          @click="$emit('edit', geolocationDetailInfo)"
        >
          <MTooltip>
            <template v-slot:trigger>
              <MIcon name="pencil" class="text-neutral" />
            </template>
            {{ $t('edit') }}
          </MTooltip>
        </a>
      </MCol>
    </MRow>
    <MRow>
      <MCol :size="3">
        <FlotoFormItemReadOnly :label="$tc('enable_geolocation')">
          <span v-if="geolocationDetailInfo.geoLocationEnable">
            {{ $tc('yes') }}
            <MTooltip v-if="!geolocationDetailInfo.locationEnabled">
              <template v-slot:trigger>
                <MIcon
                  name="exclamation-triangle"
                  class="text-secondary-orange mx-1"
                />
              </template>
              {{ 'Geolocation permission is disabled for this Asset' }}
            </MTooltip>
          </span>
          <span v-else>{{ $tc('no') }}</span>
        </FlotoFormItemReadOnly>
      </MCol>
      <MCol v-if="geolocationDetailInfo.geoLocationEnable" :size="3">
        <FlotoFormItemReadOnly :label="$tc('geolocation_preference')">
          {{ $tc(geolocationDetailInfo.geoLocationPreferenceType) || '---' }}
        </FlotoFormItemReadOnly>
      </MCol>
      <MCol v-if="geolocationDetailInfo.geoLocationEnable" :size="6">
        <FlotoFormItemReadOnly :label="$tc('default_asset_location')">
          <span
            v-if="
              geolocationDetailInfo.defaultLatitude &&
              geolocationDetailInfo.defaultLongitude
            "
          >
            {{
              `${geolocationDetailInfo.defaultLatitude}, ${geolocationDetailInfo.defaultLongitude}`
            }}
          </span>
          <span v-else>---</span>
        </FlotoFormItemReadOnly>
      </MCol>
      <MCol :size="3"> </MCol>
    </MRow>
  </div>
</template>

<script>
export default {
  name: 'GeolocationDetailItem',
  props: {
    geolocationDetailInfo: { type: Object, required: true },
    // eslint-disable-next-line
    markBgColor: { type: Boolean, default: true },
    // eslint-disable-next-line
    allowEdit: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {}
  },
}
</script>
